// ============================================
// COMPANY LAYOUT - Mobil Uyumlu
// ============================================

import { useState } from 'react';
import { Outlet } from '@tanstack/react-router';
import { CompanySidebar } from './CompanySidebar';
import { CompanyHeader } from './CompanyHeader';
import { CompanyMobileTabBar } from './CompanyMobileTabBar';
import { SupportButton } from '@/components';
import { cn } from '@/utils';

export function CompanyLayout() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Sidebar */}
      <CompanySidebar
        collapsed={sidebarCollapsed}
        onCollapsedChange={setSidebarCollapsed}
        mobileOpen={mobileOpen}
        onMobileClose={() => setMobileOpen(false)}
      />

      {/* Ana İçerik */}
      <div
        className={cn(
          'transition-all duration-300',
          // Mobilde sidebar yok, padding yok
          // Desktop'ta collapse durumuna göre
          sidebarCollapsed ? 'md:pl-16' : 'md:pl-64'
        )}
      >
        {/* Header */}
        <CompanyHeader onMenuClick={() => setMobileOpen(true)} />

        {/* Sayfa İçeriği */}
        <main className="p-4 md:p-6 pb-20 md:pb-6">
          <Outlet />
        </main>
      </div>

      {/* Mobil Alt Tab Bar */}
      <CompanyMobileTabBar onMoreClick={() => setMobileOpen(true)} />

      {/* Destek Butonu */}
      <SupportButton />
    </div>
  );
}
